import React from 'react';

import type { FaceId } from '@vlabs/api/luna-api/model';
import { Control, useModal } from '@vlabs/uikit';

import { VerifyFaceForm } from '@vlabs/monokit/entities/faces';

import { useVerifyFaceTranslation } from './i18n';

interface VerifyFaceButtonProps {
  faceId: FaceId;
  className?: string;
  disabled?: boolean;
}

function VerifyFaceButton({
  faceId,
  className = undefined,
  disabled = false,
}: VerifyFaceButtonProps): JSX.Element {
  const { t } = useVerifyFaceTranslation();
  const verifyModal = useModal({ size: 'small' });

  const handleClick = () => {
    verifyModal.open();
  };

  return (
    <React.Fragment>
      {verifyModal.wrap(<VerifyFaceForm faceId={faceId} />)}
      <Control.Button
        className={className}
        data-testid="verifyButton"
        disabled={disabled}
        kind="secondary"
        onClick={handleClick}
        size="small"
        variant="outlined"
      >
        {t('verify_button')}
      </Control.Button>
    </React.Fragment>
  );
}

export { VerifyFaceButton };
